import React from 'react';
import logo from './images/brand/CNM.webp';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Portal under construction
        </p>
        <a
          className="App-link"
          href="https://cnm.co.in"
          target="_blank"
          rel="noopener noreferrer"
        >
          Home Page
        </a>
      </header>
    </div>
  );
}

export default App;
